<mat-dialog-content style="overflow: auto; height:600pt;">
    <app-privacy-policy ></app-privacy-policy >
    <app-terms-of-use></app-terms-of-use>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button class="agree-btn" [mat-dialog-close]="true"><label translate>agree</label></button>
    <button mat-button class="decline-btn" mat-dialog-close><label translate>decline</label></button>
</mat-dialog-actions>